import { BigNumberish, ethers } from 'ethers';

import ERC1155ABI from './nft/contracts/abi/ERC1155ABI.json';

export const hasSeasonalNFT = async (
  tokenAddress: string,
  userAddress: string,
  tokenId: BigNumberish,
  provider: any
): Promise<boolean> => {
  const contract = new ethers.Contract(tokenAddress, ERC1155ABI, provider);

  return (await contract.balanceOf(userAddress, tokenId)).toNumber() > 0;
};
